import React from "react";
import PropTypes from "prop-types";
import Steps from "rc-steps";
import CompletedIcon from "assets/svgs/completedIcon.svg";

import "./Stepper.scss";

const Stepper = ({ current, stepsTotal }) => (
  <Steps
    current={current}
    className="pt-4 pb-4"
    items={stepsTotal}
    icons={{
      finish: <CompletedIcon />,
    }}
  />
);

Stepper.propTypes = {
  current: PropTypes.number.isRequired,
  stepsTotal: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default Stepper;
